import { Box, Collapse, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import {
  getModuleNameInArea,
  getModulesInArea,
  getModulesInTab,
} from "../../api/area";
import {
  checkAccessToWareHouseDrug,
  checkAccessToWareHouseEquipment,
  getStaticAccesses,
  hasExternalReferralAccess,
} from "../../api/jahadgar";
import DashboardIcon from "../../assets/SVG/dashboard";
import { OptionsSidebar } from "../sidebar/sidebar";

export default function SidebarAreaManager({
  data,
  setData,
  sidebarAreaData,
  Role,
}) {
  const [select, setSelect] = useState(0);
  const [moduleData, setModuleData] = useState();
  const [moduleName, setModuleName] = useState();
  const [tabNameData, setTabNameData] = useState();
  const [jahadgarRoute, setJahadgarRoute] = useState();
  const [drugLevel, setDrugLevel] = useState();
  const [equimpLevel, setEquimpLevel] = useState();
  const [referralLevel, setReferralLevel] = useState();

  useEffect(() => {
    if (data[0]?.areas[0]?.id) {
      getModuleNameInArea(data[0]?.areas[0]?.id)
        .then((x) => setModuleData(x))
        .catch(() => {});
    }
  }, [data]);

  useEffect(() => {
    if (data[0]?.areas[0]?.id && moduleName)
      getModulesInTab(data[0]?.areas[0]?.id, moduleName)
        .then((z) => setTabNameData(z))
        .catch(() => {});
  }, [data, moduleName]);

  useEffect(() => {
    if (data[0]?.areas[0]?.id) {
      getStaticAccesses(data[0]?.areas[0]?.id)
        .then((x) => {
          setJahadgarRoute(x);
        })
        .catch(() => {});
    }
  }, [data]);

  useEffect(() => {
    checkAccessToWareHouseDrug()
      .then((x) => {
        setDrugLevel(x);
      })
      .catch(() => {});
  }, []);
  useEffect(() => {
    checkAccessToWareHouseEquipment()
      .then((x) => {
        setEquimpLevel(x);
      })
      .catch(() => {});
  }, []);
  useEffect(() => {
    hasExternalReferralAccess()
      .then((x) => {
        setReferralLevel(x);
      })
      .catch(() => {});
  }, []);

  const handleModuleClick = (name) => {
    // اگر ماژول فعلی همان ماژولی است که کلیک شده، آن را ببند (null تنظیم کن)
    // در غیر این صورت، ماژول جدید را باز کن
    setModuleName(moduleName === name ? null : name);
  };

  // console.log(Object.entries(moduleData)?.length);
  if (moduleData) {
    return (
      <>
        <Box sx={{ overflow: "auto" }}>
          <OptionsSidebar
            href="/"
            onClick={() => setSelect(0)}
            select={select === 0 ? false : true}
            text="داشبورد"
            icon={
              <DashboardIcon
                color={select === 0 ? "white" : "var(--emr-disable)"}
              />
            }
          />
          {(jahadgarRoute?.dispatcher ||
            Object.entries(moduleData)?.length > 0) && (
            <OptionsSidebar
              href="/reception"
              onClick={() => setSelect(105)}
              select={select === 105 ? false : true}
              text="پذیرش"
              icon={
                <Box
                  sx={{ fontFamily: "icomoon !important " }}
                  className={"icon-reception-2-1"}
                  color={"var(--emr-disable)"}
                  fontSize="20px"
                />
              }
            />
          )}
          {(sidebarAreaData?.hasTrainSection ||
            jahadgarRoute?.trainer ||
            Object.entries(moduleData)?.length > 0) && (
            <>
              <OptionsSidebar
                href="/"
                arrowIcon
                onClick={() => {
                  handleModuleClick("آموزش");
                }}
                select={moduleName === "آموزش" ? false : true}
                text="آموزش"
                icon={
                  <Box
                    sx={{ fontFamily: "icomoon !important " }}
                    className={"icon-classroom-1"}
                    color={"var(--emr-disable)"}
                    fontSize="20px"
                  />
                }
              />
              {[
                { moduleName: "آموزش بزرگسال", href: "/education" },
                { moduleName: "آموزش کودکان", href: "/childrenEducation" },
              ].map((x, index) => (
                <Collapse
                  sx={{ px: "20px" }}
                  in={moduleName === "آموزش" ? true : false}
                  timeout="auto"
                >
                  <OptionsSidebar
                    href={x.href}
                    onClick={() => setSelect(index + 1)}
                    select={select === index + 1 ? false : true}
                    text={x.moduleName}
                    icon={
                      <DashboardIcon
                        color={
                          select === index + 1 ? "white" : "var(--emr-disable)"
                        }
                      />
                    }
                  />
                </Collapse>
              ))}
            </>
          )}
          {(sidebarAreaData?.hasInsuranceSection ||
            jahadgarRoute?.insurance ||
            Object.entries(moduleData)?.length > 0) && (
            <OptionsSidebar
              href="/insurer"
              onClick={() => setSelect(103)}
              select={select === 103 ? false : true}
              text="بیمه گر"
              icon={
                <Box
                  sx={{ fontFamily: "icomoon !important " }}
                  className={"icon-insurance-1"}
                  color={"var(--emr-disable)"}
                  fontSize="20px"
                />
              }
            />
          )}
          {moduleData &&
            Object.entries(moduleData)?.map((x, i) => (
              <>
                <OptionsSidebar
                  arrowIcon
                  onClick={() => {
                    handleModuleClick(x[0]);
                  }}
                  select={moduleName === x[0] ? false : true}
                  text={x[0]}
                  icon={
                    <Box
                      sx={{ fontFamily: "icomoon !important " }}
                      className={x[1]}
                      color={"var(--emr-disable)"}
                      fontSize="20px"
                    />
                  }
                />
                {tabNameData?.map((z, index) => (
                  <Collapse
                    sx={{ px: "20px" }}
                    in={moduleName === x[0] ? true : false}
                    timeout="auto"
                  >
                    <OptionsSidebar
                      href={
                        z.moduleName === "پذیرش"
                          ? "reception"
                          : x.moduleName === "آموزش بزرگسالان"
                          ? "education"
                          : x.moduleName === "آموزش کودکان"
                          ? "childrenEducation"
                          : x.moduleName === "بیمه گر"
                          ? "insurer"
                          : `module?${z.moduleId}?${moduleName}`
                      }
                      onClick={() => setSelect(index + 1)}
                      select={select === index + 1 ? false : true}
                      text={z.moduleName}
                      icon={
                        <DashboardIcon
                          color={
                            select === index + 1
                              ? "white"
                              : "var(--emr-disable)"
                          }
                        />
                      }
                    />
                  </Collapse>
                ))}
              </>
            ))}
          {(sidebarAreaData?.hasPharmacySection ||
            jahadgarRoute?.pharmacy ||
            Object.entries(moduleData)?.length > 0) && (
            <OptionsSidebar
              href="/drugTable"
              onClick={() => setSelect(200)}
              select={select === 200 ? false : true}
              text="داروخانه"
              icon={
                <Box
                  sx={{ fontFamily: "icomoon !important " }}
                  className={"icon-pharmacy"}
                  color={select === 200 ? "white" : "var(--emr-disable)"}
                  fontSize="20px"
                />
              }
            />
          )}
          {(jahadgarRoute?.equipment ||
            Object.entries(moduleData)?.length > 0) && (
            <OptionsSidebar
              href="/equipmentTable"
              onClick={() => setSelect(301)}
              select={select === 301 ? false : true}
              text="تجهیزات"
              icon={
                <Box
                  sx={{ fontFamily: "icomoon !important " }}
                  className={"icon-warehouse-1-1"}
                  color={select === 301 ? "white" : "var(--emr-disable)"}
                  fontSize="20px"
                />
              }
            />
          )}
          {drugLevel && (
            <OptionsSidebar
              href="/drugWarehouse"
              onClick={() => setSelect(300)}
              select={select === 300 ? false : true}
              text="انبار داروخانه"
              icon={
                <Box
                  sx={{ fontFamily: "icomoon !important " }}
                  className={"icon-pharmacy"}
                  color={select === 300 ? "white" : "var(--emr-disable)"}
                  fontSize="20px"
                />
              }
            />
          )}
          {equimpLevel && (
            <OptionsSidebar
              href="/equipmentWarehouse"
              onClick={() => setSelect(201)}
              select={select === 201 ? false : true}
              text="انبار تجهیزات"
              icon={
                <Box
                  sx={{ fontFamily: "icomoon !important " }}
                  className={"icon-warehouse-1-1"}
                  color={select === 201 ? "white" : "var(--emr-disable)"}
                  fontSize="20px"
                />
              }
            />
          )}
          {referralLevel && (
            <OptionsSidebar
              href="/erjaTable"
              onClick={() => setSelect(220)}
              select={select === 220 ? false : true}
              text="ارجاعات"
              icon={
                <Box
                  sx={{ fontFamily: "icomoon !important " }}
                  className={"icon-warehouse-1-1"}
                  color={select === 220 ? "white" : "var(--emr-disable)"}
                  fontSize="20px"
                />
              }
            />
          )}
        </Box>
      </>
    );
  }
}
